import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_SESSION_LEVEL_OFFERS = createActionTypes('FETCH_SESSION_LEVEL_OFFERS');
export const GET_SESSION_LEVEL_OFFER = createActionTypes('GET_SESSION_LEVEL_OFFER');
export const CREATE_SESSION_LEVEL_OFFER = createActionTypes('CREATE_SESSION_LEVEL_OFFER');
export const UPDATE_SESSION_LEVEL_OFFER = createActionTypes('UPDATE_SESSION_LEVEL_OFFER');
export const DELETE_SESSION_LEVEL_OFFER = createActionTypes('DELETE_SESSION_LEVEL_OFFER');
